import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class FormaDePago extends Component {
  render() {
    const { cliente } = this.props.data;

    let leyend = '';

    if (cliente.pm_type && cliente.pm_last_four) {
      leyend = cliente.pm_type + ' **** **** **** ' + cliente.pm_last_four;
    }

    return (
      <div>
        <Row className="mb-2">
          <Col>
            <h5 className="pt-3">Mi Tarjeta</h5>
            {
              leyend && <p>Actualmente tienes registrada tu tarjeta <strong>{ leyend }</strong></p>
            }
          </Col>
        </Row>
        <Row>
          <Col>
            <Link to="/cuenta/forma-de-pago" className="mr-3">
              <Button type="button"
                variant="secondary"
              >
                <FontAwesomeIcon icon={ ['fas', 'plus-square'] } className="mr-3" />
                Registrar nueva tarjeta
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
    )
  }
}

export default FormaDePago;